// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 94 ? "pdfjsWorker" : chunkId) + "." + {"94":"0751024f","379":"9cf7dca1","629":"a64cf3e6"}[chunkId] + ".chunk.js";
};